import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%'
  }
}))

const Dot = ({ color }) => {
  const classes = useStyles()

  return <div className={classes.dot} style={{ backgroundColor: color }}></div>
}

export default Dot
